export default function PersonIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8571 6.57143C14.8571 8.26773 13.482 9.64286 11.7857 9.64286C10.0894 9.64286 8.71429 8.26773 8.71429 6.57143C8.71429 4.87513 10.0894 3.5 11.7857 3.5C13.482 3.5 14.8571 4.87513 14.8571 6.57143ZM15.8571 6.57143C15.8571 8.82002 14.0343 10.6429 11.7857 10.6429C9.53713 10.6429 7.71429 8.82002 7.71429 6.57143C7.71429 4.32284 9.53713 2.5 11.7857 2.5C14.0343 2.5 15.8571 4.32284 15.8571 6.57143ZM17.4121 19.3843C17.5198 19.2978 17.5589 19.2419 17.5714 19.2181C17.5606 16.032 14.9744 13.4524 11.7857 13.4524C8.59035 13.4524 6 16.0427 6 19.2381C6 19.3653 6.03586 19.4675 6.18728 19.5984C6.3716 19.7578 6.70795 19.9329 7.25381 20.0837C8.34388 20.3849 9.92601 20.5 11.7857 20.5C13.5934 20.5 15.179 20.2802 16.2771 19.9262C16.8312 19.7476 17.2009 19.5539 17.4121 19.3843ZM17.5766 19.2051C17.5769 19.2051 17.5763 19.2079 17.5736 19.2136C17.5749 19.2079 17.5762 19.2051 17.5766 19.2051ZM18.5714 19.2381C18.5714 20.5952 15.5334 21.5 11.7857 21.5C8.03807 21.5 5 21.0476 5 19.2381C5 15.4904 8.03807 12.4524 11.7857 12.4524C15.5334 12.4524 18.5714 15.4904 18.5714 19.2381Z"
          fill="white"
        />
      </svg>
    </>
  );
}
